import React, { useState, useEffect } from "react";
import { Button, Dialog, DialogContent, IconButton, TextField, Typography, InputLabel, MenuItem, Select, FormControl, Stack, } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import styled from "styled-components";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;

const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const CityModal = ({ onClose, fetchData, propData }) => {
    const [form, setForm] = useState({ name: "" });
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [category, setCategory] = useState("");

    useEffect(() => {
        if (propData) {
            setName(propData?.name || "");
            setCategory(propData?.category || "");
        }
    }, [propData]);

    const submitHandler = async () => {
        if (!name.trim() || !category.trim()) {
            window.NotificationUtils.showError("Please fill The Details");
            return;
        }
        setLoading(true);
        try {
            if (propData) {
                await window.Platform.database.updateCity({
                    name: name,
                    category:category,
                    id: propData.id,
                });
                window.NotificationUtils.showSuccess("Update successfully");
            } else {
                let result = await window.Platform.database.addCity({ name, category });
                window.NotificationUtils.showSuccess(result?.message);
            }
            setName("");
            setCategory("");
            fetchData();
            onClose();
        } catch (err) {
            window.NotificationUtils.showError(err?.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog disableEnforceFocus maxWidth="sm" fullWidth open>
            <StyledDialogContent>
                <ModalHeaderContainer>
                    <Typography variant="h5">{propData ? "Edit" : "Add New"} City </Typography>
                    <IconButton onClick={onClose}>
                        <CloseOutlined />
                    </IconButton>
                </ModalHeaderContainer>

                {loading && <OpaqueLoading />}

                <Stack gap={2} padding={2}>
                    <FormControl fullWidth>

                        <TextField
                            label="Name"
                            value={name || ''}
                            type="text"
                            // onChange={(e) => setName(e.target.value)}
                            onChange={(e) => setName(e.target.value.replace(/^\s+/, ""))}
                            fullWidth
                        />

                    </FormControl>
                    <FormControl fullWidth>
                        <TextField
                            label="category"
                            value={category || ''}
                            type="text"
                            // onChange={(e) => setName(e.target.value)}
                            onChange={(e) => setCategory(e.target.value.replace(/^\s+/, ""))}
                            fullWidth
                        />
                    </FormControl>

                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                        <Button
                            color="primary"
                            variant="contained"
                            onClick={submitHandler}
                            disabled={!name || !category}
                        >
                            {propData ? 'Update' : 'Create'}
                        </Button>
                    </div>
                </Stack>
            </StyledDialogContent>

        </Dialog>
    );
};

export default CityModal;
